import { useEffect } from 'react';

import { AnalyticsEvent } from 'shared/constants/analytics';
import { useAnalytics } from 'shared/hooks/analytics';
import { useStudent, useUserRole } from 'shared/hooks/user';
import { UserRole } from 'shared/types';

export const useAnalyticsMasqueradingSessionDuration = () => {
  const analytics = useAnalytics();
  // TODO: reuse useIsAdminView hook after topic(GSP-596): sidebar updates will be merged to master
  const student = useStudent();
  const role = useUserRole();

  useEffect(() => {
    if (student && (role === UserRole.Staff || role === UserRole.Admin)) {
      analytics.timeEvent(AnalyticsEvent.StudentsMasqueradeSessionDuration);
    }
  }, [analytics, role, student]);
};
